export default __webpack_public_path__ + "static/media/Osteoarthritis-1.e6915ef6.jpg";